// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Material Icons';
  font-style: normal;
  font-weight: 400;
  src: url('https://fonts.gstatic.com/s/materialicons/v36/flUhRq6tzZclQEJ-Vdg-IuiaDsNc.woff2')
    format('woff2');
}
/*TODO: Replace 14px with 16px to correct tailwind*/
html,
body {
  font:
    normal 14px / 1.5 bebas-neue,
    sans-serif;
  -webkit-font-smoothing: antialiased;
}

a {
  text-decoration: none;
  color: inherit;
}

.CXBQf9LTwzuGBluJBrsh {
  align-items: flex-start !important;
}
`, "",{"version":3,"sources":["webpack://./index.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB;mBACiB;AACnB;AACA,mDAAmD;AACnD;;EAEE;;cAEY;EACZ,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":["@font-face {\n  font-family: 'Material Icons';\n  font-style: normal;\n  font-weight: 400;\n  src: url('https://fonts.gstatic.com/s/materialicons/v36/flUhRq6tzZclQEJ-Vdg-IuiaDsNc.woff2')\n    format('woff2');\n}\n/*TODO: Replace 14px with 16px to correct tailwind*/\nhtml,\nbody {\n  font:\n    normal 14px / 1.5 bebas-neue,\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n}\n\na {\n  text-decoration: none;\n  color: inherit;\n}\n\n.MuiTab-wrapper {\n  align-items: flex-start !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"MuiTab-wrapper": `CXBQf9LTwzuGBluJBrsh`
};
export default ___CSS_LOADER_EXPORT___;
